/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createEffectiveRevenue } from '../fn/effective-revenue/create-effective-revenue';
import { CreateEffectiveRevenue$Params } from '../fn/effective-revenue/create-effective-revenue';
import { deleteEffectiveRevenue } from '../fn/effective-revenue/delete-effective-revenue';
import { DeleteEffectiveRevenue$Params } from '../fn/effective-revenue/delete-effective-revenue';
import { EffectiveRevenueDto } from '../models/effective-revenue-dto';
import { EffectiveRevenueDtoPage } from '../models/effective-revenue-dto-page';
import { getEffectiveRevenue } from '../fn/effective-revenue/get-effective-revenue';
import { GetEffectiveRevenue$Params } from '../fn/effective-revenue/get-effective-revenue';
import { listEffectiveRevenues } from '../fn/effective-revenue/list-effective-revenues';
import { ListEffectiveRevenues$Params } from '../fn/effective-revenue/list-effective-revenues';
import { updateEffectiveRevenue } from '../fn/effective-revenue/update-effective-revenue';
import { UpdateEffectiveRevenue$Params } from '../fn/effective-revenue/update-effective-revenue';

@Injectable({ providedIn: 'root' })
export class EffectiveRevenueApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listEffectiveRevenues()` */
  static readonly ListEffectiveRevenuesPath = '/v0/effectiveRevenue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEffectiveRevenues()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEffectiveRevenues$Response(params?: ListEffectiveRevenues$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveRevenueDtoPage>> {
    return listEffectiveRevenues(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEffectiveRevenues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEffectiveRevenues(params?: ListEffectiveRevenues$Params, context?: HttpContext): Observable<EffectiveRevenueDtoPage> {
    return this.listEffectiveRevenues$Response(params, context).pipe(
      map((r: StrictHttpResponse<EffectiveRevenueDtoPage>): EffectiveRevenueDtoPage => r.body)
    );
  }

  /** Path part for operation `createEffectiveRevenue()` */
  static readonly CreateEffectiveRevenuePath = '/v0/effectiveRevenue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEffectiveRevenue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEffectiveRevenue$Response(params: CreateEffectiveRevenue$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return createEffectiveRevenue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEffectiveRevenue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEffectiveRevenue(params: CreateEffectiveRevenue$Params, context?: HttpContext): Observable<string> {
    return this.createEffectiveRevenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getEffectiveRevenue()` */
  static readonly GetEffectiveRevenuePath = '/v0/effectiveRevenue/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEffectiveRevenue()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveRevenue$Response(params: GetEffectiveRevenue$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveRevenueDto>> {
    return getEffectiveRevenue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEffectiveRevenue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveRevenue(params: GetEffectiveRevenue$Params, context?: HttpContext): Observable<EffectiveRevenueDto> {
    return this.getEffectiveRevenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<EffectiveRevenueDto>): EffectiveRevenueDto => r.body)
    );
  }

  /** Path part for operation `updateEffectiveRevenue()` */
  static readonly UpdateEffectiveRevenuePath = '/v0/effectiveRevenue/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEffectiveRevenue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEffectiveRevenue$Response(params: UpdateEffectiveRevenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateEffectiveRevenue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEffectiveRevenue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEffectiveRevenue(params: UpdateEffectiveRevenue$Params, context?: HttpContext): Observable<void> {
    return this.updateEffectiveRevenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteEffectiveRevenue()` */
  static readonly DeleteEffectiveRevenuePath = '/v0/effectiveRevenue/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEffectiveRevenue()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEffectiveRevenue$Response(params: DeleteEffectiveRevenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEffectiveRevenue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEffectiveRevenue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEffectiveRevenue(params: DeleteEffectiveRevenue$Params, context?: HttpContext): Observable<void> {
    return this.deleteEffectiveRevenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
